import React, { useState, useEffect } from 'react'
import './page.css'
import './layouts.css'

/**
 * Page Context
 */
export const PageContext = React.createContext({})

/**
 * Page Provider
 */
export const PageProvider = ({ context = {}, children }) => {
    
    const [pageCtx, setPageCtx] = useState(context)

    return (
        <PageContext.Provider value={[pageCtx, setPageCtx]}>
            {children}
        </PageContext.Provider>
    )
}

/**
 * Page
 */
export const Page = (props) => {
    const { children, layout = "simple", context = {} } = props
    return (
        <PageProvider context={context}>
            <article className={`page6 ${layout}`}>
                {children}
            </article>
        </PageProvider>
    )
}
